import React from 'react'
import WidgetBot from '@widgetbot/react-embed'

export default function ChatInstance () {
  return (
    <WidgetBot
      server='629411177947987986'
      channel='814215103146623006'
      style={{ height: '100%', width: '100%', border: '0px' }}
    />
  )
}
